import { AiPowerIcon } from "@/components/icons";
import { webRoutes } from "@/config/web/routes";
import { Button } from "@/modules/shadcn/ui/button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export interface ModelRunningProps {
  projectId: number;
  message?: string;
  hideButton?: boolean;
}

export const ModelRunning = ({
  projectId,
  message,
  hideButton,
}: ModelRunningProps) => {
  const { t } = useTranslation("camera");
  const runHref = webRoutes.run.replace(":projectId", String(projectId));

  return (
    <div className="flex flex-1 flex-col items-center justify-center p-8">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10 [&_svg]:size-8 [&_svg]:text-destructive">
        <AiPowerIcon />
      </div>

      <p className="mb-2 text-xl font-semibold text-black">
        {t("connection.modelRunning.title")}
      </p>

      <p className="mb-6 text-sm text-black/60">
        {message ?? t("connection.modelRunning.description")}
      </p>

      {!hideButton && (
        <Link to={runHref}>
          <Button>{t("connection.modelRunning.goToRun")}</Button>
        </Link>
      )}
    </div>
  );
};
